module.exports = __webpack_public_path__ + "static/mo19-1d4b07616a698fbd9fb6556cc7c93197.png";